import { render } from "./ElectricalDamage.vue?vue&type=template&id=0e87112a&scoped=true&ts=true"
import script from "./ElectricalDamage.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamage.vue?vue&type=script&lang=ts"

import "./ElectricalDamage.vue?vue&type=style&index=0&id=0e87112a&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e87112a"]])

export default __exports__